<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JZjAqC/tc-custom/9781416583226.jpg?1718160607307" alt="This image is the cover for the book Why Marriage Matters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Why Marriage Matters
      </h1>
      <p class="bookDescription body article font2">
        <b>"At its core, the freedom-to-marry movement is about the same thing every civil rights struggle has been about: taking seriously our country's promise to be a nation its citizens can make better, its promise to be a place where people don't have to give up their differences or hide them in order to be treated equally."</b><br/><br/><i>Why Marriage Matters</i> offers a compelling, intelligently reasoned discussion of a question that still remains in the national consciousness. It is the work of one of the most influential attorneys in America, who has dedicated his life to the protection of individuals' rights and our Constitution's commitment to equal justice under the law. Above all, it is a clear, straightforward book that brings into sharp focus the very human significance of the right to marry in America—not just for some couples, but for all.<br/><br/>Why is the word <i>marriage</i> so important? Will marriage for same-sex couples hurt the "sanctity" of the institution? How can people of different faiths reconcile their beliefs with the idea of marriage for same-sex couples? How will allowing gay couples to marry affect children?<br/><br/>In this quietly powerful volume, the most authoritative and fairly articulated book on the subject, Wolfson demonstrates why the right to marry is important—indeed necessary—for all couples and for America's promise of equality.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Evan Wolfson
      </h2>
      
      <p class="authorDescription body article">Evan&#160;Wolfson&#160;is an attorney and gay rights activist. He founded Freedom to Marry, the gay and non-gay partnership that worked to win marriage equality nationwide until its 2015 victory. Before founding Freedom to Marry,&#160;Wolfson&#160;served as marriage project director for Lambda Legal Defense &amp; Education Fund, was co-counsel in the historic Hawaii marriage case,&#160;Baehr&#160;v.&#160;Miike, and participated in numerous gay rights and&#160;HIV/AIDS cases. Between his studies at Yale College and Harvard Law School,&#160;Wolfson&#160;spent two years with the Peace Corps in West Africa and then worked as a state prosecutor and special counsel in the Iran/Contra investigation. Citing his national leadership on marriage equality and his appearance before the U.S. Supreme Court in Boy Scouts of America v. James Dale, the National Law Journal in 2000 named&#160;Wolfson&#160;one of &quot;the 100 most influential lawyers in America.&quot; In 2004, he was named one of the &quot;Time 100,&quot; Time magazine&#39;s list of &quot;The 100 most influential people in the world.&quot;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon & Schuster
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6e9e6956